(function() {
  'use strict';
  
  // Language detection and translation object
  const translations = {
    ja: {
      currencySymbol: '¥',
      yearSuffix: '年',
      monthSuffix: '月',
      daySuffix: '日'
    },
    en: {
      currencySymbol: '¥',
      yearSuffix: '/',
      monthSuffix: '/',
      daySuffix: ''
    }
  };
  
  // Detect user's language preference
  function getUserLanguage() {
    const shopifyLang = document.documentElement.lang || '';
    if (shopifyLang.startsWith('ja')) return 'ja';
    if (shopifyLang.startsWith('en')) return 'en';
    
    const browserLang = navigator.language || navigator.userLanguage || 'en';
    return browserLang.startsWith('ja') ? 'ja' : 'en';
  }
  
  const currentLang = getUserLanguage();
  const t = translations[currentLang];
  
  function parseAmount(text) {
    const cleaned = text.replace(/[¥,$,\s]/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  function formatAmount(number) {
    const locale = currentLang === 'ja' ? 'ja-JP' : 'en-US';
    return t.currencySymbol + Math.round(number).toLocaleString(locale);
  }
  
  function getCheckinCheckout() {
    const izyDateInput = document.querySelector('.izyDate');
    if (izyDateInput && izyDateInput._flatpickr) {
      const dates = izyDateInput._flatpickr.selectedDates;
      if (dates && dates.length >= 2) {
        return {
          checkin: new Date(dates[0]),
          checkout: new Date(dates[1]),
          method: 'flatpickr'
        };
      }
    }
    
    if (window.izyrent && window.izyrent.selectedDates) {
      if (window.izyrent.selectedDates.length >= 2) {
        return {
          checkin: new Date(window.izyrent.selectedDates[0]),
          checkout: new Date(window.izyrent.selectedDates[1]),
          method: 'window.izyrent'
        };
      }
    }
    
    const recapDateDiv = document.getElementById('recapDate');
    if (recapDateDiv) {
      const dateText = recapDateDiv.textContent.trim();
      if (dateText) {
        return {
          text: dateText,
          method: 'recapDate'
        };
      }
    }
    
    const recapContainer = document.getElementById('izyRecap');
    if (recapContainer) {
      const fullText = recapContainer.textContent;
      
      // Support both Japanese and English date patterns
      const dateTimePattern = /(\d{4}\/\d{1,2}\/\d{1,2}\s+\d{1,2}:\d{2}|\d{1,2}月\d{1,2}日\s+\d{1,2}:\d{2}|\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2})/g;
      const matches = fullText.match(dateTimePattern);
      
      if (matches && matches.length >= 2) {
        return {
          checkin: matches[0],
          checkout: matches[1],
          method: 'pattern-datetime'
        };
      }
      
      const datePattern = /(\d{4}\/\d{1,2}\/\d{1,2}|\d{1,2}月\d{1,2}日|\d{1,2}\/\d{1,2}\/\d{4})/g;
      const dateMatches = fullText.match(datePattern);
      
      if (dateMatches && dateMatches.length >= 2) {
        return {
          checkin: dateMatches[0],
          checkout: dateMatches[1],
          method: 'pattern-date'
        };
      }
    }
    
    return null;
  }
  
  function formatDateTime(date) {
    if (!date) return '';
    
    if (date instanceof Date && !isNaN(date)) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      if (currentLang === 'ja') {
        if (hours === '00' && minutes === '00') {
          return `${year}${t.yearSuffix}${month}${t.monthSuffix}${day}${t.daySuffix}`;
        }
        return `${year}${t.yearSuffix}${month}${t.monthSuffix}${day}${t.daySuffix} ${hours}:${minutes}`;
      } else {
        // English format: MM/DD/YYYY or MM/DD/YYYY HH:MM
        if (hours === '00' && minutes === '00') {
          return `${month}/${day}/${year}`;
        }
        return `${month}/${day}/${year} ${hours}:${minutes}`;
      }
    }
    
    return String(date);
  }
  
  function syncRecapToLineItem() {
    const recapContainer = document.getElementById('izyRecap');
    const totalValueBlock = document.querySelector('.total_value_block');
    
    if (!recapContainer) {
      if (totalValueBlock) {
        totalValueBlock.style.display = 'none';
      }
      return;
    }
    
    const nbdaysElement = recapContainer.querySelector('.nbdays');
    const amountElement = recapContainer.querySelector('.amount');
    
    if (!nbdaysElement || !amountElement) {
      if (totalValueBlock) {
        totalValueBlock.style.display = 'none';
      }
      return;
    }
    
    const daysText = nbdaysElement.textContent.trim();
    const amountText = amountElement.textContent.trim();
    const recapAmount = parseAmount(amountText);
    const dates = getCheckinCheckout();
    
    if (recapAmount <= 0) {
      if (totalValueBlock) {
        totalValueBlock.style.display = 'none';
      }
      updateFields(daysText, amountText, dates);
      return;
    }
    
    let addonsTotal = 0;
    const addonPriceElements = document.querySelectorAll('#izyAddons .addonPrice');
    
    if (addonPriceElements.length > 0) {
      addonPriceElements.forEach(function(priceEl) {
        const priceText = priceEl.textContent.trim();
        const priceValue = parseAmount(priceText);
        
        if (priceValue > 0) {
          addonsTotal += priceValue;
        }
      });
    }
    
    const totalAmount = recapAmount + addonsTotal;
    
    if (totalAmount <= 0) {
      if (totalValueBlock) {
        totalValueBlock.style.display = 'none';
      }
      updateFields(daysText, amountText, dates);
      return;
    }
    
    const formattedTotal = formatAmount(totalAmount);
    updateFields(daysText, amountText, dates, formattedTotal);
    
    if (totalValueBlock) {
      totalValueBlock.style.display = '';
    }
  }
  
  function updateFields(daysText, amountText, dates, totalValue) {
    const targetDays = document.querySelector('.line-item-property__fielder .days');
    const targetAmount = document.querySelector('.line-item-property__fielder .amount');
    const targetCheckin = document.querySelector('.line-item-property__fielder .checkin');
    const targetCheckout = document.querySelector('.line-item-property__fielder .checkout');
    
    const inputTotal = document.getElementById('haku-total');
    const inputCheckin = document.getElementById('haku-checkin');
    const inputCheckout = document.getElementById('haku-checkout');
    
    const totalValueDiv = document.querySelector('.total_value');
    
    if (targetDays) {
      targetDays.textContent = daysText;
    }
    
    if (targetAmount) {
      targetAmount.textContent = amountText;
    }
    
    if (inputTotal) {
      inputTotal.value = daysText + ' ' + amountText;
    }
    
    if (dates) {
      let checkinText = '';
      let checkoutText = '';
      
      if (dates.method === 'flatpickr' || dates.method === 'window.izyrent') {
        checkinText = formatDateTime(dates.checkin);
        checkoutText = formatDateTime(dates.checkout);
      } else if (dates.method === 'recapDate' || dates.method === 'pattern-datetime' || dates.method === 'pattern-date') {
        if (dates.text) {
          const parts = dates.text.split(/→|~|−|–|to|\s-\s/);
          if (parts.length >= 2) {
            checkinText = parts[0].trim();
            checkoutText = parts[1].trim();
          } else {
            checkinText = dates.text;
          }
        } else if (dates.checkin && dates.checkout) {
          checkinText = String(dates.checkin);
          checkoutText = String(dates.checkout);
        }
      }
      
      if (targetCheckin && checkinText) {
        targetCheckin.textContent = checkinText;
      }
      
      if (targetCheckout && checkoutText) {
        targetCheckout.textContent = checkoutText;
      }
      
      if (inputCheckin && checkinText) {
        inputCheckin.value = checkinText;
      }
      
      if (inputCheckout && checkoutText) {
        inputCheckout.value = checkoutText;
      }
    }
    
    if (totalValue && totalValueDiv) {
      totalValueDiv.textContent = totalValue;
    }
  }
  
  function setupEventListeners() {
    const events = [
      'izyrentCheckDate',
      'izyrentChange',
      'izyrentRefresh',
      'izyrentAddons',
      'izyrentReady'
    ];
    
    events.forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        setTimeout(syncRecapToLineItem, 50);
        setTimeout(syncRecapToLineItem, 200);
      });
    });
    
    const recapContainer = document.getElementById('izyRecap');
    if (recapContainer) {
      const recapObserver = new MutationObserver(function() {
        syncRecapToLineItem();
      });
      
      recapObserver.observe(recapContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    const addonsContainer = document.getElementById('izyAddons');
    if (addonsContainer) {
      const addonsObserver = new MutationObserver(function() {
        syncRecapToLineItem();
      });
      
      addonsObserver.observe(addonsContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    const recapDateDiv = document.getElementById('recapDate');
    if (recapDateDiv) {
      const dateObserver = new MutationObserver(function() {
        syncRecapToLineItem();
      });
      
      dateObserver.observe(recapDateDiv, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    document.addEventListener('input', function(e) {
      if (e.target.classList.contains('izyBox') || 
          e.target.classList.contains('addonQty')) {
        setTimeout(syncRecapToLineItem, 100);
      }
    }, true);
    
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('izyBox') || 
          e.target.classList.contains('addonQty')) {
        setTimeout(syncRecapToLineItem, 100);
      }
    }, true);
    
    let checkCount = 0;
    const intervalId = setInterval(function() {
      checkCount++;
      
      const recap = document.getElementById('izyRecap');
      if (recap) {
        const hasNbdays = recap.querySelector('.nbdays');
        const hasAmount = recap.querySelector('.amount');
        
        if (hasNbdays && hasAmount) {
          syncRecapToLineItem();
          clearInterval(intervalId);
        }
      }
      
      if (checkCount >= 40) {
        clearInterval(intervalId);
      }
    }, 500);
  }
  
  function init() {
    const totalValueBlock = document.querySelector('.total_value_block');
    if (totalValueBlock) {
      totalValueBlock.style.display = 'none';
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setupEventListeners();
        setTimeout(syncRecapToLineItem, 1000);
      });
    } else {
      setupEventListeners();
      setTimeout(syncRecapToLineItem, 1000);
    }
  }
  
  init();
})();
